// extracted by mini-css-extract-plugin
export default {"viewer":"NVHWPJd5cTSsfIn3nPXW","body":"o4NZBNP5lE05WxEq4_tO","currentImage":"zn1Gf3XnMa0ZlsRJ0fB1","requestSecondary":"B6B4wbWaySwR2jKZDguZ"};